import { NgModule } from '@angular/core';
import { NGRX_BUCKETS } from '@curbnturf/entities';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import * as listingEffects from './+state/listing.effects';
import { initialState as listingInitialState, listingReducer } from './+state/listing.reducer';

@NgModule({
  providers: [
    provideState(NGRX_BUCKETS.listing, listingReducer, {
      initialState: listingInitialState,
    }),
    provideEffects(listingEffects),
  ],
})
export class ListingModule {}
